import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftSelect from 'components/SoftSelect';

const CurrencySelector = ({ baseOptions = null, selectedCurrency, setSelectedCurrency }) => {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Si se pasan opciones base, se usan directamente y se evita la petición a la API
    if (baseOptions !== null) {
      setOptions(baseOptions);
      setIsLoading(false);
      return;
    }

    // Configuramos el cancel token para axios
    const source = axios.CancelToken.source();

    axios.get(`${process.env.REACT_APP_SERVER_URL}/api/finance/currency-types/`, {
      cancelToken: source.token,
    })
      .then(response => {
        const data = response.data;
        console.log(data)
        // Mapeamos la data para ajustarla al formato requerido por SoftSelect
        const mappedOptions = data.results.map(option => ({
          label: option.name,
          value: option.id,
          ...option,
        }));
        setOptions(mappedOptions);
        setIsLoading(false);
      })
      .catch(err => {
        if (axios.isCancel(err)) {
          console.log('Request canceled:', err.message);
        } else {
          setError(err.message);
          setIsLoading(false);
        }
      });

    // Cleanup: cancelar la petición si el componente se desmonta
    return () => {
      source.cancel('Operation canceled by the user.');
    };
  }, [baseOptions]);

  return (
    <SoftBox>
      <SoftTypography 
        variant="caption"
        fontWeight="bold"
        color="text"
      >
        Currencys
      </SoftTypography>
      <SoftSelect
        options={options}
        value={options.find(option => option.value === selectedCurrency)}
        onChange={setSelectedCurrency}
        isLoading={isLoading}
        placeholder="Seleccione un currency"
        error={error}
      />
    </SoftBox>
  );
};

CurrencySelector.propTypes = {
  baseOptions: PropTypes.array,
  selectedCurrency: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.number,
    PropTypes.string,
  ]),
  setSelectedCurrency: PropTypes.func,
};

export default CurrencySelector;
